import PropTypes from "prop-types";

export const fileType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  type: PropTypes.string,
  class: PropTypes.string,
  mime_type: PropTypes.string,
  preview_url: PropTypes.string,
  download_url: PropTypes.string,
  created_by_id: PropTypes.number,
  created_on: PropTypes.number,
  size: PropTypes.number,
  sizeValue: PropTypes.number,
});
